import { classNames } from 'primereact/utils'
import { FC, useState } from 'react'
import useAppSelector from '../../../hooks/useAppSelector'
import { FloatingButton } from '../../FloatingButton/FloatingButton'
import { UserHeader } from 'src/components/Header/UserHeader'
import Loader from '../../Loader'
import { Sidebar } from '../../Sidebar/Sidebar'
import { IProps } from './StudentLayout.types'

export const StudentLayout: FC<IProps> = ({ pageName = '', auth, children }) => {
    const [isVisible, setIsVisible] = useState(false)
    
    const { isShortLoading, shortInfo } = useAppSelector(
        state => state.infoReducer,
    )
    
    if (isShortLoading) {
        return <Loader />
    }
    
    return (
        <div className={classNames('w-screen flex', pageName)}>
            <Sidebar
                auth={auth}
                isVisible={isVisible}
                onHide={() => setIsVisible(false)}
                mobileData={{
                    curGroup: shortInfo.curGroup,
                }}
            />
            <div className="w-full container min-h-full" style={{ overflow: 'clip' }}>
                <UserHeader
                    setIsVisible={setIsVisible}
                    curGroup={shortInfo.curGroup}
                />
                {children}
            </div>
            <FloatingButton />
        </div>
    )
}
